module.exports = __webpack_public_path__ + "c858787cf95b92f694dbe1d296a8a5d4.svg";